import React, { ReactNode } from 'react'
import Box from '@mui/material/Box'

export const FullHeightBox = ({ children }: { children: ReactNode }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: '100%',
                alignItems: 'center',
            }}
        >
            {children}
        </Box>
    )
}
